/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidTraceability401,
  GetApiV1IndividualpaymentParcelsParcelidTraceability500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentParcelsParcelidTraceability.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentParcelsParcelidTraceability } from "../../clients/individualPaymentTraceabilityController/getApiV1IndividualpaymentParcelsParcelidTraceability.ts";

export const getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryKey = (
  parcelId: GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
) =>
  [
    {
      url: "/api/v1/individualpayment/parcels/:parcelId/traceability",
      params: { parcelId: parcelId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryKey
  >;

export function getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryOptions(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryKey(
    parcelId,
    params,
  );
  return queryOptions<
    GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidTraceability401
      | GetApiV1IndividualpaymentParcelsParcelidTraceability500
    >,
    GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
    typeof queryKey
  >({
    enabled: !!parcelId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentParcelsParcelidTraceability(
        parcelId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os registros de auditoria da parcela (GA_TRACEABILITY, entidade CourseFinPersonPayment). Com 'isBilletHistory=true' restringe aos campos relevantes do boleto (vencimento, multa, descontos, total). Migrado do legado IndividualPayment/LoadParcelTraceabilityGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna a rastreabilidade (auditoria por campo) de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/traceability}
 */
export function useGetApiV1IndividualpaymentParcelsParcelidTraceability<
  TData = GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryKey,
>(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentParcelsParcelidTraceability401
          | GetApiV1IndividualpaymentParcelsParcelidTraceability500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryKey(
      parcelId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryOptions(
        parcelId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidTraceability401
      | GetApiV1IndividualpaymentParcelsParcelidTraceability500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
